import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="31agoopp4khjz">
      <MetaPixel data-id="element-1" data-mp="31bi9vmzuukff" />
      <CountdownBar data-id="element-2" data-mp="31c1jmgfcq2id" />
      <main data-id="element-3" data-mp="31cjjro54x0vk">
        <Hero data-id="element-4" data-mp="2wka1mua9h53u" />
        <StatsBar data-id="element-5" data-mp="2wjqi594yq8np" />
        <Difference data-id="element-6" data-mp="2wj8cjlweui34" />
        <WhatsInside data-id="element-7" data-mp="2wip7v6vrtq71" />
        <Bonuses data-id="element-8" data-mp="2wi5qbra193tj" />
        <Offer data-id="element-9" data-mp="28u5uwe1s0p8m" />
        <Guarantee data-id="element-10" data-mp="28tme50nv46w6" />
        <Testimonials data-id="element-11" data-mp="28t4j27cxrypu" />
      </main>
      <Footer data-id="element-12" data-mp="28s2ztflro5x1" />
    </div>;
}